import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 37 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.42711 26.5626L4.42711 10.3563L18.4622 2.25312L32.4973 10.3563L32.4973 26.5626L18.4622 34.6657L4.42711 26.5626Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0684 19.4209L12.9972 22.3498L20.011 15.3359",
			stroke: "white",
			strokeWidth: 2.68581,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7148 20.3506L19.6437 23.2795L26.6575 16.2656",
			stroke: "white",
			strokeWidth: 2.68581,
			strokeLinecap: "round"
		})
	]
});
export default SvgLogoIcon;
